import { Link } from 'react-router-dom';
import { COMPANY, PRINCIPLES, PROCESS, SERVICES } from './content';

export function Home() {
  return (
    <>
      <section className="hero">
        <p className="eyebrow">Software development</p>
        <h1>{COMPANY.tagline}</h1>
        <p className="hero-lead">{COMPANY.intro}</p>
        <div className="hero-actions">
          <a className="btn-primary" href={`mailto:${COMPANY.email}`}>
            Get a quote
          </a>
          <Link className="btn-ghost" to="/services">
            What we build
          </Link>
        </div>
      </section>

      <section className="band">
        <h2 className="band-title">What we build</h2>
        <p className="band-sub">
          Six areas, one team. Most projects touch more than one.
        </p>
        <div className="grid-3">
          {SERVICES.map((s) => (
            <article key={s.title} className="tile">
              <h3>{s.title}</h3>
              <p>{s.summary}</p>
            </article>
          ))}
        </div>
        <Link className="band-link" to="/services">
          See what each one includes &rarr;
        </Link>
      </section>

      <section className="band">
        <h2 className="band-title">How we work</h2>
        <p className="band-sub">
          Four stages, and you can stop or change direction at any of them.
        </p>
        <ol className="steps">
          {PROCESS.map((p) => (
            <li key={p.step}>
              <span className="step-num">{p.step}</span>
              <div>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="band">
        <h2 className="band-title">What we commit to</h2>
        <p className="band-sub">
          Each of these is meant to be something you can hold us to.
        </p>
        <div className="grid-2">
          {PRINCIPLES.map((p) => (
            <article key={p.title} className="tile">
              <h3>{p.title}</h3>
              <p>{p.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="cta-band">
        <h2>Tell us what you need built.</h2>
        <p>
          Send a description of the project and we will come back with scope,
          price and a timeline — before any work starts.
        </p>
        <a className="btn-primary" href={`mailto:${COMPANY.email}`}>
          {COMPANY.email}
        </a>
      </section>
    </>
  );
}
